import { IMAGES } from "../data/content";

const SIZES = {
  hero: {
    mark: "h-24 sm:h-32 lg:h-40",
    word: "text-3xl sm:text-5xl lg:text-6xl tracking-[0.22em] sm:tracking-[0.3em]",
    tag: "text-sm sm:text-base tracking-[0.35em] mt-4",
    gap: "-mb-3 sm:-mb-5",
  },
  footer: {
    mark: "h-16",
    word: "text-2xl tracking-[0.28em]",
    tag: "text-xs tracking-[0.3em] mt-2",
    gap: "-mb-2",
  },
};

// Brand lockup: gold script "Y" above the elegant Cinzel wordmark + gold tagline.
export default function BrandLockup({ size = "hero", tagline = true, align = "center", className = "" }) {
  const s = SIZES[size];
  const alignCls = align === "left" ? "items-start text-left" : "items-center text-center";
  return (
    <div className={`flex flex-col ${alignCls} ${className}`} data-testid="brand-lockup">
      <img src={IMAGES.logoMark} alt="Your Black Limo emblem" className={`${s.mark} ${s.gap} w-auto object-contain`} />
      <span className={`font-wordmark ${s.word} text-[#F5F5F0] leading-none`}>YOUR&nbsp;BLACK&nbsp;LIMO</span>
      {tagline && (
        <span className={`font-script ${s.tag} text-[#C5A059] uppercase`}>Tuscany, Understated.</span>
      )}
    </div>
  );
}
